module.exports = __webpack_public_path__ + "media/photo/AdobeStock_300874234_Update_Wider-aa8f13f1.jpg";